module.exports = __webpack_public_path__ + "img/apple-app-store-badge.2928664f.svg";